exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UserBar__profileHeader___1ZVwG {\n\tpadding: 0.8rem 0.8rem;\n\tdisplay: flex;\n\ttext-decoration: none;\n\tcolor: mainTextColour;\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.UserBar__sideImg___2fguX {\n\twidth: 3rem;\n\theight: 3rem;\n}\n\n.UserBar__spacer___3BBSW {\n\tmargin-right: 1rem;\n}\n\n.UserBar__profileHeaderDetails___3YGnO {\n\tdisplay: flex;\n\talign-items : center;\n\tjustify-content: space-between;\n\twhite-space: nowrap;\n\tmargin-left: auto;\n}\n\n.UserBar__userName___1kgaZ {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.UserBar__link___30iNy {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n", ""]);

// exports
exports.locals = {
	"profileHeader": "UserBar__profileHeader___1ZVwG",
	"sideImg": "UserBar__sideImg___2fguX",
	"spacer": "UserBar__spacer___3BBSW",
	"profileHeaderDetails": "UserBar__profileHeaderDetails___3YGnO",
	"userName": "UserBar__userName___1kgaZ",
	"link": "UserBar__link___30iNy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/UserBar.icss
// module id = 1466
// module chunks = 0